(function () {
    'use strict';

    angular
        .module('app.truck')
        .run(appRun);

    appRun.$inject = ['routerHelper'];
    /* @ngInject */
    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'truck',
                config: {
                    url: '/truck',
                    abstract: true,
                    template: '<ui-view/>',
                    ncyBreadcrumb: {
                        label: 'Truck'
                    },
                    data: {
                        permissions: {
                            only: ['AUTHORIZED'],
                            redirectTo: function () {
                                return {
                                    state: 'error.403',
                                    options: {
                                        reload: true
                                    }
                                };
                            }
                        }
                    }
                }
            },
            {
                state: 'truck.dashboard',
                config: {
                    url: '/dashboard',
                    templateUrl: 'app/truck/dashboard/truck.dashboard.html',
                    controller: 'TruckManagementDashboardController',
                    controllerAs: 'vm',
                    title: 'Truck Management',
                    settings: {
                        isVisible: true,
                        nav: 3,
                        content: '<i class="fa fa-truck"></i> Truck Management'
                    }
                }
            }
        ];
    }
})();
